import { Drawer } from '@reveni-io/reveni-ui'

import ReviewRecommendationsStep from './steps/ReviewRecommendationsStep/ReviewRecommendationsStep'

const FixInventoryItemsDrawer = ({
  show,
  onClose,
  draftItems,
  progressItems,
  showHts,
  confirmingDraftItems,
  onConfirmChanges,
}) => {
  return (
    <Drawer show={show} onClose={onClose} options={{ showHeaderActions: false }}>
      <ReviewRecommendationsStep
        draftItems={draftItems}
        progressItems={progressItems}
        showHts={showHts}
        confirmingDraftItems={confirmingDraftItems}
        onConfirm={onConfirmChanges}
        onStop={onClose}
      />
    </Drawer>
  )
}

export default FixInventoryItemsDrawer
